// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const clinicalCategory = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_CLINICAL_CATEGORY':
      return {
        ...state,
        data: action.data,
        total: action.total,
        params: action.params,
        from: action.from,
        to: action.to
      }
    case 'GET_CLINICAL_CATEGORY':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_CLINICAL_CATEGORY':
      return { ...state }
    case 'UPDATE_CLINICAL_CATEGORY':
      return { ...state }
    case 'DELETE_CLINICAL_CATEGORY':
      return { ...state }
    default:
      return { ...state }
  }
}

export default clinicalCategory
